export default __webpack_public_path__ + "static/media/Arrow.e4f311dc.svg";